<template v-if="options">
    <div class="search-filters-item mb-4">
        <h6 class="search-filters-item__title text-primary" v-if="name" v-html="name" />
        <ul class="search-filters-item__list">
            <SearchFiltersOption
                v-for="(option, index) in options"
                :key="index"
                :name="option.name"
                :value="option.value"
                :count="option.count"
                :type="option.type"
                :slug="option.slug"
                :taxonomy="option.taxonomy && option.taxonomy"
            />
        </ul>
    </div>
</template>

<script>
import SearchFiltersOption from './search-filters-option';

export default {
    components: {
        SearchFiltersOption
    },
    props: {
        items: {
            type: Object,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        taxonomy: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        /**
         * Return object populated with correct keys and values.
         * @return {{name, count, type: String, value, slug: string}[]}
         */
        options() {
            const items = Object.keys( this.items ).map( key => {
                const item = {
                    type: this.type,
                    name: this.capitalize( this.items[ key ].name ),
                    count: this.items[ key ].count,
                    value: this.items[ key ].value,
                    slug: key
                };

                // Extend with the taxonomy, if it's a taxonomy.
                if ( this.type === 'taxonomy' ) {
                    Object.assign( item, { slug: key, taxonomy: this.taxonomy } );
                }

                return item;
            } );

            if( 'year' === this.type ) {
                // Sort Year descending.
                return items.sort((a, b) => b.name - a.name);
            }

            // Sort Alphabetically.
            return items.sort((a, b) => a.name.localeCompare(b.name));
        }
    },

    methods:{
        /**
         * Capitalize the string.
         * @param {string} string The string to capitalize.
         * @return {*}
         */
        capitalize(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }
};
</script>
